// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
import { getMessaging, getToken } from "firebase/messaging"
import { Platform } from "react-native"
import { onUpdateFCMToken } from "./api"

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC-c_P3f_l7GDjXSYJZDY535O5C5RwXMF0",
  authDomain: "symple-dekode.firebaseapp.com",
  projectId: "symple-dekode",
  storageBucket: "symple-dekode.appspot.com",
  messagingSenderId: "707420053287",
  appId: "1:707420053287:web:f6344765b29414d44ad302",
}

const firebaseApp = initializeApp(firebaseConfig)
const messaging = getMessaging(firebaseApp)

export const getWebFCMToken = (accessToken, memberId) => {
  if (Platform.OS === "web" && navigator.serviceWorker) {
    navigator.serviceWorker
      .register(`/firebase-messaging-sw.js`)
      .then((registration) => {
        Notification.requestPermission()
          .then((permission) => {
            if (permission === "granted") {
              return getToken(messaging, {
                vapidKey:
                  "BHz--LaFdvjxo0lQaRy05KvnuDEuuFdgOGB0KfJZoCUNg0dhBeXUdIO7aa_6T-GgXK-0S9Tm4_otOHF3cTnpjN8",
                serviceWorkerRegistration: registration,
              })
                .then((currentToken) => {
                  if (currentToken) {
                    console.log("current token for client: ", currentToken)
                    onUpdateFCMToken(accessToken, memberId, currentToken)
                  } else {
                    console.log(
                      "No registration token available. Request permission to generate one.",
                    )
                  }
                })
                .catch((err) => {
                  console.log("An error occurred while retrieving token. ", err)
                })
            }
          })
          .catch((e) => {
            console.error("Service Worker registration failed:", e)
          })
      })
      .catch((error) => {
        console.error("Service Worker registration failed:", error)
      })
  }
}
